"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridSelectorItem = exports.GridSelector = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _arrowIcon = _interopRequireDefault(require("../arrow-icon"));

var _heading = _interopRequireDefault(require("../heading"));

var _icon = _interopRequireDefault(require("../icon"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var _excluded = ["className", "title", "subtitle", "linkUrl", "linkElement", "children", "color", "uppercase", "body", "iconType"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GridSelector = function GridSelector(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.GridSelector, className)
  }, children);
};

exports.GridSelector = GridSelector;
GridSelector.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string
};

var GridSelectorItem = function GridSelectorItem(_ref2) {
  var _cx;

  var className = _ref2.className,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      linkUrl = _ref2.linkUrl,
      linkElement = _ref2.linkElement,
      children = _ref2.children,
      color = _ref2.color,
      uppercase = _ref2.uppercase,
      body = _ref2.body,
      iconType = _ref2.iconType,
      props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);

  // eslint-disable-next-line jsx-a11y/anchor-has-content
  var Link = linkElement || function (props) {
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, props, {
      href: linkUrl
    }));
  };

  return /*#__PURE__*/_react.default.createElement(Link, {
    className: (0, _classnames.default)(_indexModule.default.GridSelectorItem, className, (_cx = {}, (0, _defineProperty2.default)(_cx, _indexModule.default.seasonal, color === 'seasonal'), (0, _defineProperty2.default)(_cx, _indexModule.default.black, color === 'black'), (0, _defineProperty2.default)(_cx, _indexModule.default.uppercase, uppercase), _cx))
  }, iconType === null ? null : /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: iconType,
    size: "medium",
    className: _indexModule.default.icon
  }), /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement(_heading.default, {
    type: "small",
    "data-test-id": props.dataTestTitle
  }, title), /*#__PURE__*/_react.default.createElement(_heading.default, {
    type: "extrasmall",
    className: _indexModule.default.subtitle,
    "data-test-id": props.dataTestSubtitle
  }, subtitle), body && /*#__PURE__*/_react.default.createElement(_heading.default, {
    type: "extrasmall",
    className: _indexModule.default.subtitle,
    "data-test-id": props.dataTestBody
  }, body)), children && /*#__PURE__*/_react.default.createElement("section", {
    className: _indexModule.default.itemBody
  }, children), /*#__PURE__*/_react.default.createElement(_arrowIcon.default, {
    className: _indexModule.default.arrow
  }));
};

exports.GridSelectorItem = GridSelectorItem;
GridSelectorItem.defaultProps = {
  color: 'seasonal',
  uppercase: true
};
GridSelectorItem.propTypes = {
  className: _propTypes.default.string,
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.string,
  dataTestSubtitle: _propTypes.default.string,
  dataTestBody: _propTypes.default.string,
  dataTestTitle: _propTypes.default.string,
  linkUrl: _propTypes.default.string,
  linkElement: _propTypes.default.func,
  children: _propTypes.default.node,
  color: (0, _propTypes.oneOf)(['black', 'seasonal']),
  uppercase: _propTypes.default.bool,
  body: _propTypes.default.node,
  iconType: _propTypes.default.string
};